/**
 * Updates the global status announcer for screen reader users.
 * The announcer element must be present in the DOM on initial page load.
 *
 * @param {string} message - Status text to announce
 * @param {{ clearAfterMs?: number }} [options]
 */
function announceStatus(message, options = {}) {
  const { clearAfterMs = 1000 } = options;
  const announcer =
    document.getElementById('global-status-announcer') ||
    document.getElementById('FacetResultsStatus');

  if (!announcer || !message) return;

  announcer.textContent = '';

  requestAnimationFrame(() => {
    announcer.textContent = message;

    if (clearAfterMs > 0) {
      window.clearTimeout(announcer._announceStatusTimeout);
      announcer._announceStatusTimeout = window.setTimeout(() => {
        announcer.textContent = '';
      }, clearAfterMs);
    }
  });
}

window.announceStatus = announceStatus;
